// Baris Total yang menempel di dasar layar selama tabelnya masih terlihat (Opsi 1 yang dipilih Deddy).
// (Sempat diganti Opsi 2 "di ujung tabel" di v2026-11-01.02, lalu dikembalikan ke menempel di .04 atas permintaan Deddy.)
// Taruh sebagai anak TERAKHIR dari pembungkus halaman/kartu: ia menempel di dasar layar
// saat tabel masih di layar, dan berhenti di ujung pembungkusnya.
// Di HP ia duduk di atas menu bawah aplikasi.
const WARNA = { in: 'text-[#9fd6ae]', out: 'text-[#f2aaa5]' };

export function TotalBar({ judul, items, catatan, testid = 'total-bar', className = '' }) {
  if (!items || items.length === 0) return null;
  return (
    <div
      data-testid={testid}
      className={`sticky bottom-[76px] md:bottom-3 z-30 rounded-2xl bg-choco text-white px-4 py-2.5 md:py-3 shadow-[0_-6px_24px_rgba(59,40,28,0.3)] ${className}`}
    >
      <p data-testid={`${testid}-judul`} className="text-[10px] uppercase tracking-[0.1em] text-white/70 font-semibold leading-snug">{judul}</p>
      <div className="mt-1 flex flex-wrap gap-x-5 gap-y-1">
        {items.map((it) => (
          <div key={it.id || it.label} className="min-w-0">
            <p className="text-[10px] text-white/60 leading-none">{it.label}</p>
            <p data-testid={`${testid}-${it.id || it.label}`} className={`font-display text-[15px] md:text-lg leading-tight mt-0.5 whitespace-nowrap ${WARNA[it.tone] || ''}`}>{it.value}</p>
          </div>
        ))}
      </div>
      {catatan ? <p data-testid={`${testid}-catatan`} className="text-[10px] text-white/55 mt-1 leading-snug">{catatan}</p> : null}
    </div>
  );
}
